<template>
  <div id="users">
    <div class="columns">
      <div class="column is-half">
        <div class="loading" v-if="loading">Laden...</div>

        <div class="error" v-if="error">{{ error }}</div>
      </div>

      <div class="column is-one-quarter is-one-quarter-offset">
        <router-link :to="{ name: 'user-edit', params: { id: false } }" class="button">Nieuwe gebruiker</router-link>
      </div>
    </div>

    <div class="columns">
      <div class="column">
        <ul>
          <router-link
          v-for="user in users"
          :key="user.id"
          :to="{ name: 'user-edit', params: { id: user.id } }"
          tag="li"
          :class="{ 'has-text-weight-bold': user.is_active }"
          >{{ user.firstname }} {{ user.lastname }} - {{ user.email }}</router-link>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    data() {
      return {
        loading: false,
        users: null,
        errors: null,
      };
    },
    created () {
      this.fetchData();
    },
    methods: {
      fetchData () {
        this.error = this.users = null;
        this.loading = true;
        axios
          .get('/users')
          .then(response => {
            this.loading = false;
            this.users = response.data;
          }).catch(error => {
            this.loading = false;
            this.error = error.response.data.message || error.message;
          });
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/users/Users.vue